import React from 'react';
import { Burger } from '@mantine/core';
import styles from './styles.scoped.css';
import { analytics } from '../../../../utils/firebase';
import { Link } from 'react-router-dom';
import LogoMap from '../../../icons/logo';
import PropTypes from 'prop-types';
import { useMediaQuery } from '@mantine/hooks';
import { logEvent } from 'firebase/analytics';

function NavbarLayout({ opened, navs, theme, setOpened }) {
  const matchesMobile = useMediaQuery('(max-width: 768px)');
  const getClassName = (n) => {
    const isActive =
      (location?.pathname !== '/'
        ? location.pathname.includes(n.to) && n.to !== '/'
        : location.pathname === n.to) || location.pathname === n.sub;

    return isActive ? styles['active'] : styles['link-parent'];
  };

  return (
    <div
      className={styles.aside}
      hidden={!opened && matchesMobile}
      width={{ sm: 300, lg: 300 }}
    >
      <div className={styles.navActionWrapper}>
        <div className={styles.logo}>
          {matchesMobile && (
            <div>
              <Burger
                color={theme?.colors?.dark[6]}
                mr="xl"
                onClick={() => setOpened((o) => !o)}
                opened={opened}
                size="md"
              />
            </div>
          )}
          <LogoMap className={styles.logoMap} />
          <div>
            <p>DASHBOARD CONSOLE</p>
            <h5>SUBSIDI TEPAT</h5>
          </div>
        </div>
        {navs.map((n, idx) => {
          let child = [];
          const linkProps = {
            onClick: () => {
              if (n.to && !n.child) {
                logEvent(analytics, 'click_menu', {
                  target: n.to,
                  name: n.name,
                });
                setOpened(false);
              } else {
                logEvent(analytics, 'click_submenu', {
                  target: n.to,
                  name: n.name,
                });
              }
            },
          };
          if (n.child) {
            const linkChild = n.child.map((i, idy) => (
              <div key={`${idx}${idy}`} onClick={() => setOpened(false)}>
                <Link
                  className={[
                    styles['link-child'],
                    (location.pathname.includes(i.to) ||
                      location.pathname === i.sub) &&
                    styles['active'],
                  ]
                    .filter(Boolean)
                    .join(' ')}
                  to={i.to}
                >
                  {/* {i.icon} */}
                  {i.name}
                </Link>
              </div>
            ));
            child = [...child, linkChild];
            linkProps.onClick = () => {
              n.onClick && !n.show && n.onClick();
              n.show = !n.show;
            };
          }
          return (
            <React.Fragment key={idx}>
              <Link
                className={getClassName(n)}
                {...linkProps}
                r={n.to}
                to={n.to && !n.child ? n.to : '#'}
              >
                {n.icon}
                {n.name}
                {n.child && (
                  <img
                    alt="Show More"
                    className={styles.arrow}
                    src={n.show ? '/assets/ic-up.svg' : '/assets/ic-down.svg'}
                  />
                )}
              </Link>
              {n.show && <div>{child}</div>}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}

export default NavbarLayout;

NavbarLayout.propTypes = {
  navs: PropTypes.array,
  opened: PropTypes.bool,
  setOpened: PropTypes.func,
  theme: PropTypes.object,
};
